import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ljmsj",
  "use": "icon-ljmsj-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-ljmsj\">\n<g>\n\t<path d=\"M12.138,4.807l-3.101,9.465H7.069L4.147,4.807l-0.06,0.06v9.405H1.882V3.259h3.875l2.325,8.037h0.06l2.504-8.037h3.697\n\t\tv11.013h-2.206V4.867V4.807z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol